/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import Notifications from '@/components/common/NotificationPlugin';

//vue tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

//import VueSlider component
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
Vue.component('VueSlider', VueSlider);

// router setup
import router from './routes/router';
import store from "./store";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(Notifications);

// import i18n
import i18n from './locales/i18n';

import pageTitleMixin from "@/mixins/pageTitleMixin";
import timeMixin from "@/mixins/timeMixin";
import cameraMixin from "@/mixins/cameraMixin";
Vue.mixin(pageTitleMixin);
Vue.mixin(timeMixin);
Vue.mixin(cameraMixin);

// import global filters
import '@/filters/filters';

import "./registerServiceWorker";
import './util/EventBus.js';

import socketCluster from './services/socket.service';
(async () => {
	socketCluster.create();
	await socketCluster.listen('connect', () => {
		console.log({ socketEvent: 'connect' });
	});
	await socketCluster.listen('disconnect', ({ code, reason }) => {
		console.log({ socketEvent: 'disconnect', code, reason });
	});
})();

/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: (h) => h(App),
	store,
	router,
	i18n,
});
